import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Pencil, X, HelpCircle } from "lucide-react";

const empty = { question: "", answer: "" };

const AdminFaqs = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);

  const load = () => api.get("/faqs").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const reset = () => { setForm(empty); setEditingId(null); };
  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) { await api.put(`/faqs/${editingId}`, form); toast.success("FAQ actualizada"); }
      else { await api.post("/faqs", form); toast.success("FAQ agregada"); }
      reset(); load();
    } catch { toast.error("No se pudo guardar"); }
  };
  const edit = (f) => { setEditingId(f.id); setForm({ question: f.question, answer: f.answer }); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const remove = async (id) => { if (!window.confirm("¿Eliminar esta pregunta?")) return; await api.delete(`/faqs/${id}`); toast.success("Eliminada"); if (editingId === id) reset(); load(); };

  return (
    <div className="mt-8">
      <form onSubmit={submit} data-testid="faq-form" className="bg-white border border-[#E5E5E5] rounded-sm p-6 mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-lg font-bold text-brand-ink flex items-center gap-2"><HelpCircle size={18} className="text-brand-magenta" /> {editingId ? "Editar pregunta" : "Nueva pregunta"}</h2>
          {editingId && <button type="button" onClick={reset} data-testid="faq-cancel" className="inline-flex items-center gap-1 text-sm text-brand-ink/60"><X size={15} /> Cancelar</button>}
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-semibold text-brand-ink">Pregunta</label>
            <input required data-testid="faq-question" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta" />
          </div>
          <div>
            <label className="text-sm font-semibold text-brand-ink">Respuesta (un párrafo por línea)</label>
            <textarea rows={6} required data-testid="faq-answer" value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta" />
          </div>
        </div>
        <button type="submit" data-testid="save-faq-btn" className="mt-4 inline-flex items-center gap-2 bg-brand-magenta text-white font-semibold px-5 py-2.5 rounded-sm hover:bg-brand-orange"><Plus size={16} /> {editingId ? "Guardar" : "Agregar"}</button>
      </form>

      <div className="grid grid-cols-1 gap-3">
        {items.map((f) => (
          <div key={f.id} data-testid={`admin-faq-${f.id}`} className="bg-white border border-[#E5E5E5] rounded-sm p-4 flex items-start gap-3">
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-brand-ink">{f.question}</h3>
              <p className="text-xs text-brand-ink/50 line-clamp-2 mt-1">{f.answer}</p>
            </div>
            <button data-testid={`edit-faq-${f.id}`} onClick={() => edit(f)} className="p-2 text-brand-ink hover:text-brand-magenta"><Pencil size={16} /></button>
            <button data-testid={`delete-faq-${f.id}`} onClick={() => remove(f.id)} className="p-2 text-brand-ink hover:text-red-600"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminFaqs;
